module.exports = __webpack_public_path__ + "img/logo_navbar.9af0a7bd.png";